import React from 'react';
import { Button, Typography } from '@mui/material';
import { trackEvent } from '@surfline/web-common';

import WavetrakLink from 'components/WavetrakLink';
import withContentCards from 'components/withContentCards';
import type { WithCardProps } from 'components/withContentCards/withContentCards';

import styles from './PremiumUpgradePillCTA.module.scss';

interface BrazeCard {
  name?: string;
  extras?: {
    box__body?: string;
    box__title?: string;
    box__link?: string;
  } | null;
}

interface Props extends WithCardProps {
  card?: BrazeCard;
  segmentProperties?: {
    location?: string;
  };
  dataTest?: string;
}

export const PremiumUpgradePillCTA: React.FC<Props> = ({
  card,
  segmentProperties,
  dataTest = 'premium-upgrade-pill-cta',
}) =>
  card?.extras ? (
    <div className={styles.ctaWrap} data-testid={dataTest}>
      <div className={styles.ctaInner}>
        <WavetrakLink
          className={styles.ctaContent}
          href={card?.extras?.box__link || '/upgrade'}
          isExternal
          onClick={() => {
            trackEvent('Clicked Subscribe CTA', segmentProperties);
          }}
        >
          <Typography
            whiteSpace="nowrap"
            className={styles.ctaText}
            variant="callout1"
            color="text.brandSecondary"
          >
            {card?.extras?.box__title}
          </Typography>
          <Button
            disableFocusRipple
            disableRipple
            disableTouchRipple
            variant="primary"
            size="medium"
            className={styles.ctaButton}
          >
            {card?.extras?.box__body}
          </Button>
        </WavetrakLink>
      </div>
    </div>
  ) : null;

export default withContentCards(PremiumUpgradePillCTA);
